<template>
  <business-management-page />
</template>

<script>
import BusinessManagementPage from '../components/business-management/BusinessManagementPage.vue';
export default {
  name: "BusinessManagement",
  components: {
    BusinessManagementPage,
  },
};
</script>

<style>
</style>